import { round } from "mathjs";

export const showPercentage = (value: number) => {
  if (isNaN(value) === true || !isFinite(value)) {
    return 0;
  } else {
    return round(value * 1000) / 10;
  }
};
